import { useGetInsolvencies } from "@/queries/users/insolvencies.api";
import { Icon, Badge } from "@elaniintc/goes-design-system";
import { useState } from "react";
import IconWrapper from "../components/icon-wrapper";
import InsolvencyFormModal from "./insolvency-form-modal";
import InsolvencyListModal from "@/pages/procedures/components/form/insolvency-list-modal";

interface InsolvenciesProps {
  userName: string;
  userId: string;
}

const Insolvencies = ({ userName, userId }: InsolvenciesProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, isLoading, error } = useGetInsolvencies(userId);

  const insolvencyCount = data?.meta?.total ?? data?.data?.length ?? 0;

  const hasActiveInsolvencies =
    !isLoading &&
    insolvencyCount > 0 &&
    !error &&
    !!data?.data?.some((insolvency) => insolvency.status === "ACTIVE");

  const hasInsolvencies = !isLoading && insolvencyCount > 0 && !error;

  const insolvencyLabel =
    insolvencyCount === 1 ? "1 Infracción" : `${insolvencyCount} Infracciones`;

  return (
    <div>
      <div className={`py-5 w-full border-neutral-quiet border-y`}>
        {hasInsolvencies ? (
          <div className="group flex items-center justify-between gap-4">
            <button
              className="flex items-center gap-3 text-action transition-opacity duration-200 hover:opacity-90 cursor-pointer"
              type="button"
              onClick={() => setIsModalOpen(true)}
            >
              <IconWrapper
                className={
                  hasActiveInsolvencies
                    ? "border-warning bg-surface-warning-accent group-hover:bg-surface-warning-accent-hover"
                    : "transition-all duration-200 group-hover:border-action hover:bg-neutral-object-accent"
                }
              >
                <Icon
                  type="far"
                  name="sack-dollar"
                  className={
                    hasActiveInsolvencies ? "text-warning" : "text-action"
                  }
                />
              </IconWrapper>
              <span
                className={
                  hasActiveInsolvencies
                    ? "text-warning leading-3xl"
                    : "text-body-quiet leading-3xl"
                }
              >
                Ver infracciones
              </span>
            </button>
            <Badge
              size="sm"
              variant={hasActiveInsolvencies ? "warning" : "neutral"}
              fill="ghost"
            >
              {insolvencyLabel}
            </Badge>
          </div>
        ) : (
          <button
            className="group flex w-full items-center gap-3 cursor-pointer"
            type="button"
            onClick={() => setIsModalOpen(true)}
          >
            <IconWrapper className="transition-all duration-200 group-hover:border-action hover:bg-neutral-object-accent">
              <Icon type="far" name="plus" className="text-action" />
            </IconWrapper>
            <span className="text-body-quiet leading-3xl">
              Añadir una infracción
            </span>
          </button>
        )}
      </div>

      <InsolvencyFormModal
        isOpen={isModalOpen && !hasInsolvencies}
        onClose={() => setIsModalOpen(false)}
        userName={userName}
        userId={userId}
      />
      <InsolvencyListModal
        isOpen={isModalOpen && hasInsolvencies}
        onClose={() => setIsModalOpen(false)}
        userId={userId}
        userName={userName}
        showActions
      />
    </div>
  );
};

export default Insolvencies;
